var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rate-promotions"},[(_vm.show === 'deal' && !_vm.points_available)?_c('rate-deal'):_vm._e(),(_vm.show === 'value_adds')?_c('rate-value-adds',{attrs:{"value_adds":_vm.promotions.value_adds}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }